import { useMutation } from '@tanstack/react-query';
import { refreshTokenAuth } from '../../index';
import {
  IRefreshToken,
  IRefreshTokenResponse,
} from '../../hooks/login-sign-up/interface';

interface UseRefreshTokenOptions {
  onSuccess?: (data: IRefreshTokenResponse) => void;
  onError?: (err: unknown) => void;
}

export const useRefreshToken = ({
  onSuccess,
  onError,
}: UseRefreshTokenOptions = {}) => {
  const {
    mutate: refreshToken,
    data: refreshTokenData,
    isPending: isRefreshTokenPending,
    isSuccess: isRefreshTokenSuccess,
  } = useMutation({
    mutationFn: (payload: IRefreshToken) => refreshTokenAuth(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err) => {
      onError?.(err);
    },
  });

  return {
    refreshToken,
    refreshTokenData,
    isRefreshTokenPending,
    isRefreshTokenSuccess,
  };
};
